import { render, staticRenderFns } from "./MindsetChip.vue?vue&type=template&id=2c11ff99&scoped=true&"
import script from "./MindsetChip.vue?vue&type=script&lang=ts&"
export * from "./MindsetChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11ff99",
  null
  
)

export default component.exports